
import Layout from "../components/Layout";
import { CarteraBancoSolidario } from '../components/CarteraBancoSolidario/CarteraBancoSolidario';

const CarteraBancoSolidarioPage = () => {
    return (
        <>
        <Layout/>
        <CarteraBancoSolidario/>
        </>
    );
}

export default CarteraBancoSolidarioPage;
